import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShareArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShareArrowDown"><Path fillRule="evenodd" clipRule="evenodd" d="M12.75 1H11.25V4H3V21H21V4H12.75V1ZM12.75 4H11.25V13.1893L8.5 10.4393L7.43934 11.5L12 16.0607L16.5607 11.5L15.5 10.4393L12.75 13.1893V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShareArrowDown;
